// extracted by mini-css-extract-plugin
export default {"fullWidth":"X1QwupmA0AUH7DYjI7rF","narrow":"bm_eAnxVr8fCEL2RcFqo","wide":"sAgJRXto0Q03l0ZxopTw"};